<template>
    <section v-if="results.length > 0" id="search-results" class="block">
        <div class="container-fluid position-relative color--black topspace">
            <div class="row">
                <div class="col-12">
                    <h2 class="h1 mb-2">Zoekresultaten</h2>
                </div>

                <div class="col-12 col-lg-6">
                    <SearchResult
                        v-for="resultItem in results"
                        :key="resultItem.id"
                        :result-item="resultItem"
                    ></SearchResult>
                    <div v-if="results.length > 0" class="row">
                        <button
                            class="btn btn-primary px-4"
                            @click="executeSearch()"
                        >
                            Alle zoekresultaten
                        </button>
                    </div>
                </div>

                <div class="col-12 col-lg-6">
                    <LazyImage
                        v-for="image in images"
                        :key="image.id"
                        class="mb-1"
                        :image="image.imageObject"
                    ></LazyImage>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import LazyImage from '@/components/lazy-image';
import SearchResult from '@/components/search/search-result';
import { EventBus } from '@/js/helpers/eventbus';

export default {
    components: {
        LazyImage,
        SearchResult
    },

    data() {
        return {
            results: [],
            images: [],
            query: ''
        };
    },

    mounted() {
        EventBus.$on('search-results', this.getSearchResults);
    },

    methods: {
        getSearchResults(searchResults) {
            this.results = searchResults.results;

            if (this.results.length == 0) {
                EventBus.$emit(
                    'no-search-result',
                    'Er zijn geen zoekresultaten gevonden'
                );
            }

            this.images = searchResults.images;
            this.query = searchResults.query;
        },
        executeSearch() {
            window.location =
                this.$root.settings.searchUrl + '?q=' + this.query;
        }
    }
};
</script>
<style lang="scss" scoped>
.topspace {
    padding-top: 100px;
    @include media-breakpoint-up(md) {
        padding-top: 130px;
    }
}
</style>
